import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { alpha, styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// --------------------------------------------------------------------------------------------- //

const StyledRoot = styled('div')(({ theme }) => ({
  textAlign: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center'
}))

// --------------------------------------------------------------------------------------------- //

const StyledGradientText = styled('h1')(({ theme }) => ({
  backgroundSize: '400%',
  textAlign: 'center',
  padding: 0,
  marginTop: 8,
  marginBottom: 24,
  // letterSpacing: -0.5,
  fontWeight: 800,
  lineHeight: 1.25,
  [theme.breakpoints.up('md')]: {
    fontSize: 62
  }
}))

export default function StrategyEditor() {
  const theme = useTheme()

  return (
    <StyledRoot>
      <Container sx={{ textAlign: 'center' }}>
        <Stack spacing={2} direction="row" alignItems="center" display="inline-flex">
          <StyledGradientText>Advanced Strategy Editor</StyledGradientText>
        </Stack>

        <Typography variant="h4" sx={{ color: 'grey.500' }}>
          Create a strategy that matches your desired trading style.
        </Typography>

        <Box
          sx={{
            borderRadius: 2,
            my: { xs: 5, md: 10 }, // boxShadow: (theme) => `-40px 40px 80px ${alpha(theme.palette.common.white, 0.24)}`,
            boxShadow: theme => `0px 0px 75px 10px ${alpha(theme.palette.common.white, 0.24)}`
          }}
        >
          <video
            src="https://res.cloudinary.com/dedhivftw/video/upload/v1729419847/website-assets/StrategyEditorDemo.mp4"
            muted
            autoPlay
            loop
            playsInline
            disableRemotePlayback
            style={{ width: '100%', borderRadius: '16px', display: 'flex' }}
          />
        </Box>
      </Container>
    </StyledRoot>
  )
}
